@if (visible()) {
  @let cfg = mobileHeader.config();
  @let selection = mobileHeader.selection();
  <ui-mobile-header
    [title]="resolvedTitle()"
    [subtitle]="resolvedSubtitle()"
    [searchPlaceholder]="resolvedSearchPlaceholder()"
    [searchQuery]="resolvedSearchQuery()"
    [filterDefs]="resolvedFilterDefs()"
    [activeFilters]="resolvedActiveFilters()"
    [chips]="resolvedChips()"
    [showTitleDropdown]="cfg?.showTitleDropdown ?? false"
    [titleDropdownLabel]="cfg?.titleDropdownLabel ?? null"
    [titleEditable]="resolvedTitleEditable()"
    [titleEditOptions]="cfg?.titleEditOptions ?? null"
    [titlePlaceholder]="resolvedTitlePlaceholder()"
    [showFilterTrigger]="resolvedShowFilterTrigger()"
    [showBackButton]="shouldShowBack()"
    [initialFilterMode]="resolvedInitialFilterMode()"
    [selectionActive]="!!selection"
    [selectionLabel]="selection?.label() ?? ''"
    [showSelectAll]="selection?.showSelectAll() ?? false"
    [allSelected]="selection?.allSelected() ?? false"
    (backClick)="onBackClick()"
    (searchChange)="onSearchChange($event)"
    (searchSubmit)="onSearchSubmit($event)"
    (filterApply)="onFilterApply($event)"
    (customPillTap)="onCustomPillTap($event)"
    (chipRemove)="onChipRemove($event)"
    (clearAll)="onClearAll()"
    (titleDropdownClick)="onTitleDropdownClick()"
    (titleChange)="onTitleChange($event)"
    (selectionCancel)="selection?.onClear()"
    (selectionSelectAll)="selection?.onSelectAll()"
  >
    <app-mobile-nav-drawer headerStart />
    @if (resolvedSubtitleTemplate(); as subtitleTpl) {
      <ng-container
        headerSubtitle
        [ngTemplateOutlet]="subtitleTpl"
      ></ng-container>
    }
    @if (subBarToggleable()) {
      <span
        headerActions
        class="ui-icon-expand-arrow mobile-header-action-btn"
        [class.mobile-sub-bar-toggle-collapsed]="!subBarVisible()"
        (click)="toggleSubBar()"
      ></span>
    }
    @if (resolvedActionsTemplate(); as tpl) {
      <ng-container headerActions [ngTemplateOutlet]="tpl"></ng-container>
    }
    @for (action of inlineActions(); track action.icon) {
      <span
        headerActions
        [class]="
          (action.isLoading ? '' : action.icon) +
          ' ' +
          action.styledClass +
          (action.cssClass ? ' ' + action.cssClass : '') +
          (action.isEffectivelyDisabled ? ' mobile-header-action-disabled' : '')
        "
        [matTooltip]="action.tooltip ?? '' | translate"
        matTooltipTouchGestures="off"
        [matTooltipShowDelay]="isTouchDevice() ? 999999 : 0"
        #actionTooltip="matTooltip"
        (click)="onActionClick(action)"
        (touchstart)="onActionTouchStart(actionTooltip)"
        (touchend)="onActionTouchEnd(actionTooltip)"
        (touchmove)="onActionTouchEnd(actionTooltip)"
        (touchcancel)="onActionTouchEnd(actionTooltip)"
      >
        @if (action.isLoading) {
          <ui-preloader
            [color]="PreloaderColor.white"
            [diameter]="20"
            [@fadeIn]="'in'"
          ></ui-preloader>
        }
      </span>
    }
    @if (overflowActions().length) {
      <span
        headerActions
        class="ui-icon-more-menu mobile-header-action-btn"
        (click)="overflowSheetOpen.set(true)"
      >
      </span>
    }
  </ui-mobile-header>
  @if (resolvedSubBar()) {
    <div class="mobile-sub-bar-collapse" [class.expanded]="subBarVisible()">
      <div class="mobile-sub-bar-host">
        <ng-container [ngTemplateOutlet]="resolvedSubBar()"></ng-container>
      </div>
    </div>
  }
  <ui-bottom-sheet
    appBackClose
    [open]="overflowSheetOpen()"
    [title]="resolvedActionsSheetTitle() | translate"
    [subtitle]="resolvedActionsSheetSubtitle() | translate"
    [titleCase]="false"
    (closeEmit)="overflowSheetOpen.set(false)"
  >
    <div sheet-content class="overflow-menu-list mobile-action-sheet-list">
      @for (group of overflowGroups(); track $index) {
        <div class="overflow-menu-card">
          @for (action of group; track action.icon) {
            <button
              type="button"
              uiTouchFeedback
              class="overflow-menu-item"
              [class.danger]="action.isDanger"
              [class.disabled]="action.isEffectivelyDisabled"
              [disabled]="action.isEffectivelyDisabled"
              (click)="onOverflowActionClick(action)"
            >
              <span class="overflow-menu-icon" [class]="action.icon"></span>
              <span class="overflow-menu-label">{{
                action.label | translate
              }}</span>
            </button>
          }
        </div>
      }
    </div>
  </ui-bottom-sheet>
}
